<template>
  <v-card class="recorder transfer card--flex--toolbar">
    <v-card-title class="amber pt-0">
      <v-toolbar flat class="transparent">
        <v-toolbar-title>海外送金フォーム</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-row dense justify="end">
          <v-col class="text-right">
            <span v-if="getSubtotalItems.length === 1">{{ `小計 ${getSubtotalItems[0].sum}円` }}</span>
            <v-menu open-on-hover v-else-if="getSubtotalItems.length > 0">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ `小計（${getSubtotalItems.length}グループ）`}}</span>
              </template>
              <v-list dense>
                <v-list-item dense v-for="item in getSubtotalItems" :key="item.key">
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ `グループ${item.key}`}}</v-list-item-subtitle>
                    <v-list-item-title>{{ `小計 ${item.sum}円` }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <span>{{ `（総計 ${printTotalSum}）` }}</span>
          </v-col>
        </v-row>
        <template v-slot:extension class="px-0">
          <v-row dense align="center">
            <v-autocomplete validate-on-blur hide-details
              ref="searcher"
              v-model="form.cid"
              color="secondary"
              label="関連する顧客"
              :no-data-text="printNoDataText"
              :items="getClientItems"
              :loading="isSearching"
              :search-input.sync="form.search"
              :append-icon="getClientItems.length ? 'fal fa-times' : ''"
              @click:append="resetClientSearch"
            />
            <v-spacer></v-spacer>
            <v-btn depressed
              color="secondary"
              @click="addItem()"
              :disabled="getFormItems.length >= 20">{{ getFormItems.length >= 20 ? '20個まで投稿できます' : (form.cid ? '追加する' : '関連なしで追加する') }}</v-btn>
          </v-row>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pt-3 px-0">
      <v-form lazy-validation
        ref="form"
        v-model="form.valid"
        @submit.prevent="onSubmit">
        <v-list dense>
          <template v-for="(item, idx) in getFormItems">
            <v-list-item :key="item.id">
              <v-list-item-content>
                <v-list-item-subtitle>
                  <v-row dense align="center" justify="start">
                    <v-col cols="8" class="body-1 py-0 black--text">{{ `${idx + 1}/${getFormItems.length}：${item.client.name ? item.client.name.replace(',', ' ') : ''}` }}</v-col>
                  </v-row>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <v-row dense align="center">
                    <v-col cols="4" class="pl-2 text-right">
                      <v-select solo flat hide-details
                        v-model="item.inc"
                        :items="getGroupItems"
                        label="グループ"
                      />
                    </v-col>
                    <v-col cols="8" class="pl-2 text-right">
                      <v-switch hide-details inset dense
                        v-model="item.floor"
                        class="mt-0 pt-0 text-right"
                        color="secondary"
                        :label="`${item.yen}（${item.floor ? '切捨' : '切上'}）`"
                      />
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
                <v-list-item-title>
                  <v-row dense align="center">
                    <v-col cols="4">
                      <v-combobox solo flat validate-on-blur
                        v-model="item.item"
                        label="勘定項目"
                        counter="10"
                        :items="getItemLabelItems"
                        background-color="grey lighten-3"
                        :rules="rules.required"
                        @change="verifyItem(item)"
                      />
                    </v-col>
                    <v-col cols="2" class="pr-0">
                      <v-select solo flat validate-on-blur
                        v-model="item.currency"
                        label="通貨"
                        :items="getCurrencyItems"
                        :append-icon="null"
                        background-color="grey lighten-3"
                        :rules="rules.required"
                        @change="verifyCurrency(item)"
                      />
                    </v-col>
                    <v-col :cols="item.currency === 'JPY' ? 6 : 3" class="pl-0">
                      <v-text-field solo flat validate-on-blur
                        v-model="item.sum"
                        class="text-right"
                        label="金額"
                        background-color="grey lighten-3"
                        :rules="rules.required"
                        @blur="verifySum({ id: item.id, format: true })"
                        @focus="verifySum({ id: item.id, format: false })"
                      />
                    </v-col>
                    <v-col cols="3" v-if="item.currency !== 'JPY'">
                      <v-text-field solo flat validate-on-blur
                        class="text-right"
                        v-model="item.rate"
                        label="レート"
                        prefix="@"
                        background-color="grey lighten-3"
                        :rules="rules.required"
                        :readonly="item.currency === 'JPY'"
                        @blur="verifyRate({ id: item.id, format: true })"
                        @focus="verifyRate({ id: item.id, format: false })"
                      />
                    </v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn fab outlined small
                  color="red"
                  @click="removeItem(item.id)">
                  <v-icon small>fal fa-trash-alt</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="`${item.id}_div`"></v-divider>
          </template>
        </v-list>
        <v-row dense class="px-4">
          <v-col cols="12">
            <v-textarea
              v-model="form.note"
              label="備考欄"
              counter="100"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text
        color="secondary"
        @click="close">閉じる</v-btn>
      <v-spacer></v-spacer>
      <v-menu offset-y
        v-model="config.datepicker"
        transition="scale-transition"
        min-width="290px"
        :close-on-content-click="false"
        :nudge-right="40">
        <template v-slot:activator="{ on }">
          <v-text-field readonly validate-on-blur hide-details
            v-on="on"
            v-model="printFormDate"
            color="primary"
            class="pb-2"
            label="送金日"
          />
        </template>
        <v-date-picker no-title
          v-model="form.date"
          locale="ja"
          color="amber"
          :day-format="date => new Date(date).getUTCDate()"
          @input="config.datepicker = false"
        />
      </v-menu>
      <v-btn depressed
        color="secondary"
        class="ml-4"
        :loading="isLoading"
        :disabled="!isValid || getFormItems.length === 0"
        @click="post">
        {{ isSetId ? '更新する' : '投稿する' }}
      </v-btn>
    </v-card-actions>
    <Confirmer ref="confirmer" />
  </v-card>
</template>

<script>
import _ from 'lodash'
import Confirmer from '@/components/modals/confirm'
export default {
  name: 'recorderCredit',
  props: [ 'client' ],
  components: {
    Confirmer
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          searching: false
        },
        datepicker: false
      },
      meta: {
        items: [
          '学費',
          '滞在費用',
          '航空券代金',
          '査証費用',
          'サポート費用',
          '送迎費用',
          '個人費用',
          '外注費',
          '送金手数料'
        ],
        currency: {
          USD: 'US$',
          CAD: 'CA$',
          NZD: 'NZ$',
          PHP: 'PH₱',
          AUD: 'AU$',
          KRW: 'KR₩',
          TWD: 'NT$',
          EUR: 'EU€',
          GBP: 'GB£',
          JPY: 'JP¥'
        }
      },
      store: {
        clients: []
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ],
        array: {
          required: [
            v => !!v.length || '必須項目'
          ]
        }
      },
      form: {
        valid: true,
        search: '',
        id: '',
        date: '',
        items: [],
        note: ''
      }
    }
  },
  methods: {
    onSubmit: function () { return false },
    init: function (req) {
      const { id, cid, date, items, note } = req || {}
      this.$set(this.config, 'status', {
        loading: false,
        searching: false
      })
      this.$set(this, 'form', {
        valid: true,
        search: '',
        id,
        date: date ? date : this.$moment().format('YYYY-MM-DD'),
        items: [],
        note: note ? note : ''
      })
      if (items && items.length) {
        for (let i = 0; i < items.length; i++) {
          this.addItem(items[i])
        }
      }
    },
    close: function () {
      this.$emit('close')
    },
    post: function () {
      this.submit({ type: !this.form.id ? 'insert' : 'update' })
    },
    remove: function () {
      this.$refs.confirmer.open({
        message: 'この投稿を削除してもよろしいですか？',
        callback: () => {
          this.submit({ type: 'remove' })
        }
      })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id, cid, date, items, note, search } = this.form
      const aid = this.$store.getters['author/get']('userid')
      const developer = this.$store.getters['author/get']('roles').includes('developer')
      const urls = {
        insert: `${this.$url.api}posts/insert/transfer`,
        update: `${this.$url.api}posts/update/transfer/${id}`,
        remove: `${this.$url.api}posts/remove/transfer/${id}`,
        client: `${this.$url.api}client/get/items`,
      }
      const fds = {
        insert: { aid, date, items: items.length ? items.map(it => {
          const { client, item, currency, sum, rate, inc, floor } = it
          return {
            client,
            item, currency,
            sum: sum ? sum.replace(',', '') : '0.00',
            rate: rate ? rate.replace(',', '') : '0.00',
            inc,
            floor
          }
        }) : [], note },
        update: { cid, aid, date, items: items.length ? items.map(it => {
          const { client, item, currency, sum, rate, inc, floor } = it
          return {
            client,
            item, currency,
            sum: sum ? sum.replace(',', '') : '0.00',
            rate: rate ? rate.replace(',', '') : '0.00',
            inc,
            floor
          }
        }) : [], note },
        remove: { cid, aid, type: 'transfer' },
        client: { name: search }
      }
      if (type && urls[type] && fds[type]) {
        if ([ 'insert', 'update' ].includes(type)) {
          const url = urls[type]
          const fd = fds[type]
          if (this.$refs.form.validate()) {
            this.$set(this.config.status, 'loading', true)
            return { url, fd, type }
          } else {
            return false
          }
        } else if (type === 'client' && search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      const socket = this.$store.getters['config/get']('socket')
      const type = postType || ''
      if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'clients', req)
      } else {
        if (!socket.connected) {
          socket.connect()
        }
        socket.emit('POST_POST_TRANSFER', req, (res) => {
          console.log(res)
          this.$emit('done', req)
          this.init()
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    searchClient: _.debounce(function (val) {
      this.submit({ type: 'client' })
    }, 300),
    verifyItem: function (req) {
      const { id } = req
      const idx = this.form.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        if (this.form.items[idx].item === '送金手数料') {
          this.$set(this.form.items[idx], 'currency', 'JPY')
          this.$set(this.form.items[idx], 'sum', '500.00')
          this.$set(this.form.items[idx], 'rate', '1.00')
        }
      }
    },
    verifyCurrency: function (req) {
      const { id } = req
      const idx = this.form.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        if (this.form.items[idx].currency === 'JPY') {
          this.$set(this.form.items[idx], 'rate', '1.00')
        }
        this.verifySum(Object.assign({ format: true }, req))
        this.verifyRate(Object.assign({ format: true }, req))
      }
    },
    verifySum: function (req) {
      const { id, format } = req
      const idx = this.form.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        const { sum, currency } = {
          // eslint-disable-next-line
          sum: this.form.items[idx].sum ? this.form.items[idx].sum.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }).replace(/,/g, '') : '0',
          currency: this.form.items[idx].currency
        }
        if (format) {
          this.$set(this.form.items[idx], 'sum', isFinite(sum) ? `${parseFloat(sum) < 100000000 ? parseFloat(sum).toFixed(2) : '0.00'}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0')
        } else {
          this.$set(this.form.items[idx], 'sum', parseInt(sum) === 0 ? '' : sum.replace(/,/g, ''))
        }
      }
    },
    verifyRate: function (req) {
      const { id, format } = req
      const idx = this.form.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        const { rate, currency } = {
          // eslint-disable-next-line
          rate: this.form.items[idx].rate ? this.form.items[idx].rate.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0.00',
          currency: this.form.items[idx].currency
        }
        if (format) {
          this.$set(this.form.items[idx], 'rate', isFinite(rate) ? `${parseFloat(rate) < 1000 ? parseFloat(rate).toFixed(currency === 'KRW' ? 4 : 2) : '0.00'}` : '0.00')
        } else {
          this.$set(this.form.items[idx], 'rate', parseInt(rate) === 0 ? '' : rate)
        }
      }
    },
    resetClientSearch: function () {
      this.$set(this.form, 'cid', '')
      this.$set(this.store, 'clients', [])
    },
    addItem: function (req) {
      const lastItem = this.form.items.length ? this.form.items[this.form.items.length - 1] : null
      const { item, currency, sum, rate, inc, cid, client, floor } = req || {
        cid: this.form.cid,
        currency: lastItem ? lastItem.currency : 'USD',
        rate: lastItem ? lastItem.rate : '0.00',
        inc: lastItem ? lastItem.inc : 'A',
        floor: lastItem ? lastItem.floor : true
      }
      const idx = this.store.clients.findIndex(it => {
         return it.id === cid
      })
      this.form.items.push({
        id: this.$uuid(),
        client: client || this.store.clients[idx] || { id: '', name: '関連なし' },
        item: item || '',
        currency: currency || 'USD',
        sum: sum || '0.00',
        rate: rate || '0.00',
        inc,
        floor
      })
    },
    removeItem: function (id) {
      const idx = this.form.items.findIndex( it => { return id === it.id })
      if (idx >= 0) {
        this.form.items.splice(idx, 1)
      }
    }
  },
  watch: {
    'form.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'clients', [])
        this.$set(this.form, 'cid', '')
      }
      if (!this.config.status.searching && !this.form.cid) {
        this.searchClient()
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSetId () {
      return this.form.id
    },
    isLink () {
      return this.form.link
    },
    isSetClient () {
      return !!this.$route.params.id
    },
    printClientName () {
      return this.$store.getters['client/get']('name').join(' ')
    },
    printFormDate () {
      return this.form.date ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    printNoDataText () {
      return this.form.search ? '検索結果0件です' : 'ふりがな or 名前を入力してください'
    },
    printSubTotalSum () {
      const total = this.form.items.length ? this.form.items.reduce((prev, it) => {
        const { sum, rate, inc, floor } = { sum: parseFloat(it.sum.replace(/,/g, '')), rate: parseFloat(it.rate), inc: it.inc, floor: it.floor }
        const current = inc ? (floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)) : 0
        return prev + current
      }, 0) : 0
      return total ? `${`${total}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円` : '0円'
    },
    getSubtotalItems () {
      const subs = {}
      for (let i = 0; i < this.form.items.length; i++) {
        const it = this.form.items[i]
        const { sum, rate, inc, floor } = { sum: parseFloat(it.sum.replace(/,/g, '')), rate: parseFloat(it.rate), inc: it.inc, floor: it.floor }
        if (!subs[inc]) {
          subs[inc] = 0
        }
        subs[inc] += floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
      }
      const keys = Object.keys(subs)
      return keys.length ? keys.map(key => {
        return {
          key,
          sum: subs[key] ? `${subs[key]}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0'
        }
      }) : [{
        key: '',
        sum: '0'
      }]
    },
    printTotalSum () {
      const total = this.form.items.length ? this.form.items.reduce((prev, it) => {
        const { sum, rate, floor } = { sum: parseFloat(it.sum.replace(/,/g, '')), rate: parseFloat(it.rate), floor: it.floor }
        const current = floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
        return prev + current
      }, 0) : 0
      return total ? `${`${total}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円` : '0円'
    },
    getGroupItems () {
      return this.$mango.alphabet.split('').map(ch => {
        return {
          value: ch,
          text: `グループ${ch}`
        }
      })
    },
    getFormItems () {
      return this.form.items.map(it => {
        const { sum, rate, floor } = { sum: parseFloat(it.sum.replace(/,/g, '')), rate: parseFloat(it.rate), floor: it.floor }
        const yen = (sum && rate) ? (floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)) : 0
        return Object.assign(it, {
          yen: `${yen}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円'
        })
      })
    },
    getItemLabelItems () {
      return this.meta.items
    },
    getCurrencyItems () {
      return Object.keys(this.meta.currency).map(key => {
        return {
          value: key,
          text: this.meta.currency[key]
        }
      })
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    }
  }
}
</script>